module.exports = __webpack_public_path__ + "img/20191111170018360截图20191111160220175.5628ea3e.jpg";